import { render, staticRenderFns } from "./LayoutBlank.vue?vue&type=template&id=19aaddc2&"
import script from "./LayoutBlank.vue?vue&type=script&lang=js&"
export * from "./LayoutBlank.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports